import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface HistoryState {
  history: string[];
}

const initialState: HistoryState = {
  history: [],
};

const pageHistorySlice = createSlice({
  name: 'pageHistory',
  initialState,
  reducers: {
    addHistory: (state, action: PayloadAction<string>) => {
      state.history.push(action.payload);
    },
    resetHistory: () => ({...initialState}),
  },
});

export const {addHistory} = pageHistorySlice.actions;
export default pageHistorySlice.reducer;
